import { useAuthStore } from "stores/authStore";
import { AuthRoleType } from "types/Auth";

export const isAuthRoleCheck = (checkRole: AuthRoleType): boolean => {
  const role = useAuthStore.getState().role;
  switch (checkRole) {
    case "ROLE_A": // 어드민 권한 사용자만 접근 가능
      return role === "ROLE_A";

    case "ROLE_M": // 본인인증 이상의 권한만 접근
      return role === "ROLE_A" || role === "ROLE_M";

    case "ROLE_D": // 회원가입 이상의 권한만 접근
      return role === "ROLE_A" || role === "ROLE_M" || role === "ROLE_D";

    case "ROLE_N": // 둘러보기도 접근 가능
      return (
        role === "ROLE_A" ||
        role === "ROLE_M" ||
        role === "ROLE_D" ||
        role === "ROLE_N"
      );

    default:
      return false;
  }
};
